import React, { useState } from "react";
import { CiFilter } from "react-icons/ci";
import { useDispatch } from "react-redux";
import AButton from "../../common/form-fields-mui/AButton";
import { RightSideFilterForm } from "./RightSideFilterForm";
import APopover from "../../common/pop-hover/APophover";
// import { CSVLink } from "react-csv";
import SearchInput from "./SearchInput";
import { getStudentList } from "./../../../../../redux/studentSearch/actions";
import SelectSearchInputParam from "./SelectSearchInputParam";
import ATextAreaV2 from "../../../../../components/ATextAreaV2/ATextAreaV2";
import {
  getInputParamRegex,
  getUpdatedInputParamKey,
  getUpdatedUserInput,
  multiValuesSearchPasteHandler,
} from "../constant/student-search";

// this is for filter button style
const highLightedStyle = {
  border: "1px solid #00B0F5",
  color: "#00B0F5",
  height: "30px",
};

const NormalStyle = {
  border: "1px solid #E9ECEF",
  height: "30px",
};

const Filter = ({
  data,
  filterForm,
  inputHandler,
  removeFilterHandler,
  crossInputHandler,
  courseIdDropdown,
  searchInputForm,
  searchInputFormHandler,
  formDropdown,
  ...props
}) => {
  const dispatch = useDispatch();
  const [anchorFilterEl, setAnchorFilterEl] = useState(null);
  const [anchorAdvFilterEl, setAnchorAdvFilterEl] = useState(null);

  const [userInput, setUserInput] = useState("");

  const [searchInputParam, setSearchInputParam] = useState("psid");

  let searchParamTitleMap = {
    psid: "PSIDs",
    studentName: "student name",
    applicationId: "application IDs",
  };

  const resetInputForm = () => {
    searchInputFormHandler("psids", []);
    searchInputFormHandler("studentName", "");
    searchInputFormHandler("applicationIds", []);
  };

  const searchBatchNameHandler = (userInput) => {
    resetInputForm();
    const updatedInputParam = getUpdatedInputParamKey(searchInputParam);
    const updatedUserInput = getUpdatedUserInput(userInput, searchInputParam);
    searchInputFormHandler(updatedInputParam, updatedUserInput);
    dispatch(
      getStudentList(
        {
          ...props.regionAndBusiness,
          ...filterForm,
          [updatedInputParam]: updatedUserInput,
        },
        0
      )
    );
  };

  const onClearSearchInput = () => {
    // setSearchInputParam('psid');
    crossInputHandler();
  };

  const removerFilterWithClose = () => {
    removeFilterHandler();
    setAnchorFilterEl(null);
  };
  const applyFilterHandler = () => {
    props.applyFilterHandler();
    setAnchorFilterEl(null);
  };

  return (
    <div style={{ display: "flex" }}>
      <div className="d-flex flex-column position-relative">
        {/* <SearchInput
          className='search-input'
          onCancel={onClearSearchInput}
          searchInputValueHandler={searchBatchNameHandler}
          placeholder={`Search by ${searchParamTitleMap[searchInputParam]}`}
          // onFocus={(e) => setInputFocused(true)}
          // onBlur={() => setInputFocused(false)}
        /> */}
        <ATextAreaV2
          style={{ width: "260px" }}
          placeholder={`Search by ${searchParamTitleMap[searchInputParam]}`}
          regex={getInputParamRegex(searchInputParam)}
          searchHandler={searchBatchNameHandler}
          crossHandler={onClearSearchInput}
          key={searchInputParam}
          value={userInput}
          onInputChange={val => setUserInput(val)}
          onPaste={(e) => multiValuesSearchPasteHandler(e, (sanitizedText) => setUserInput(prev => prev + sanitizedText))}
        />
        <div className="mt-4">
          <SelectSearchInputParam
            searchInputParam={searchInputParam}
            setSearchInputParam={setSearchInputParam}
          />
        </div>
      </div>
      <AButton
        onClick={(event) => {
          setAnchorFilterEl(event.currentTarget);
        }}
        updatedStyle={
          anchorFilterEl || props.appliedFilterCount > 0
            ? highLightedStyle
            : NormalStyle
        }
      >
        <CiFilter
          style={{
            marginRight: "4px",
            height: "16px",
            width: "16px",
          }}
        />
        Filter
        {props.appliedFilterCount > 0 && (
          <span>( {props.appliedFilterCount} )</span>
        )}
      </AButton>

      <APopover
        handleClose={() => setAnchorFilterEl(null)}
        id="info-batch-filter-1"
        anchorEl={anchorFilterEl}
      >
        <RightSideFilterForm
          formModal={filterForm}
          inputHandler={inputHandler}
          applyFilterHandler={applyFilterHandler}
          removeFilterHandler={removerFilterWithClose}
          isShowRemoveFilter={!!props.appliedFilterCount}
          courseIdDropdown={courseIdDropdown}
          formDropdown={formDropdown}
        />
      </APopover>

      <APopover
        handleClose={() => setAnchorAdvFilterEl(null)}
        id="info-batch-filter"
        anchorEl={anchorAdvFilterEl}
      ></APopover>
      {/* <AButton>
			<MdOutlineSimCardDownload />
			<CSVLink
				data={data}
				headers={CSV_HEADERS}
				filename={`${Date.now()}-${"batches.csv"}`}
			>
				Download CSV
			</CSVLink>
			;
			</AButton> */}
    </div>
  );
};

export default Filter;
